import {
  INTERNATIONAL_PAYMENT_FIELDS,
  INTERNATIONAL_PAYMENT_TEXTS,
} from "../../modules/InternationalPayment/InternationalPayment.constants";

const { REQUIRED_ERROR } = INTERNATIONAL_PAYMENT_TEXTS;

export const validateFields = (formValues) =>
  INTERNATIONAL_PAYMENT_FIELDS.reduce(
    (acc, { name, required }) => ({
      ...acc,
      [name]: {
        touched: true,
        error: required && !formValues[name]?.trim() ? REQUIRED_ERROR : "",
      },
    }),
    {}
  );

export const getInitialFormState = () =>
  INTERNATIONAL_PAYMENT_FIELDS.reduce(
    (acc, { name }) => ({ ...acc, [name]: "" }),
    {}
  );

export const getInitialMetaState = () =>
  INTERNATIONAL_PAYMENT_FIELDS.reduce(
    (acc, { name }) => ({ ...acc, [name]: { touched: false, error: "" } }),
    {}
  );

export const isFormValid = (formValues) =>
  INTERNATIONAL_PAYMENT_FIELDS.every(
    ({ name, required }) => !required || formValues[name]?.trim()
  );
